import { useMemo } from "react";
import jexl from 'jexl'
import { isEditableField, getDefaultValue, isContainer, isWidget } from "../../../common/form/fieldTypes";
import { initializeCanadaAddressFields } from "../../../Widgets/AddressComplete/CanadaAddress"; 
import { initializePhoneMobileFields } from "../../../Widgets/ContactDetails/PhoneMobile";
import { initializeFirstNationStatusDetailFields } from "../../../Widgets/FNIM/FirstNationStatusDetail";
import { initializeFamilyMembersFields } from "../../../Widgets/FamilyMembers/FamilyMembers";
import { initializeDateOfBirthInputFields } from "../../../Widgets/ContactDetails/DateOfBirthInput";
import { initializeMapLocationFields } from "../../../Widgets/MapViewer/MapLocation";
import { initializeBankDetailsFields } from "../../../Widgets/BankDetails/BankDetails";
import { fieldTypes } from "../../../common/form/fieldTypes";

export const useDynamicForm = ({ form, context={} }) => {
  const {
    defaultValues,
    title,
    error,
    isLoading,
    fields,
    description,
    templateFields,
    formSettings,
  } = useMemo(() => {
    if (!form) {
      return { error: true, isLoading: false };
    }

    let error = false;
    let isLoading = false;
    const { title, description, formSettings, fields = [] } = form ?? {};

    if (fields?.length === 0) {
      error = true;
    }

    const newFields = [ ...fields ];
    const defaultValues = {};

    const initializeFields = (fields) => {
      (fields ?? []).forEach((field) => {
        
        if (isContainer(field.type)) {
          initializeFields(field.fields);
        }
        if (!isWidget(field.type) && isEditableField(field.type)) {
          const { name, defaultValue } = field.properties;
          if (!!name) {
            let value = context.form[name];
            if (!value && defaultValue) {
              try {
                value = jexl.evalSync(defaultValue, context);
              }
              catch(ex) {
                console.error(`Exception during evaluating: ${defaultValue}. Error: ${ex.message}`);
              }
            } 
            if (!value) {
              value = getDefaultValue(field?.type);
            } 
            defaultValues[name] = value;
          }       
        }
        if (field.type === fieldTypes.value && field.properties.updateFieldsWithParams) {
          if (field.properties.method === 'getRefValue') {
            defaultValues[field.properties.name] = defaultValues[field.properties.name] ?? '';    
          } else {
            Object.keys(field.properties.params ?? []).forEach(name => {
              defaultValues[name] = defaultValues[name] ?? '';      
            });
          }
        }
        if (field.type === fieldTypes.dateWidget) {
          initializeDateOfBirthInputFields(defaultValues, context.form);
        }
        if (field.type === fieldTypes.phoneWidget) {
          initializePhoneMobileFields(defaultValues, context.form);
        }
        if (field.type === fieldTypes.addressWidget) {
          initializeCanadaAddressFields(defaultValues, context.form);
        }
        if (field.type === fieldTypes.firstNationStatusWidget) {
          initializeFirstNationStatusDetailFields(defaultValues, context.form);
        }
        if (field.type === fieldTypes.familyMembersWidget) {
          initializeFamilyMembersFields(defaultValues, context.form);
        }
        if (field.type == fieldTypes.mapLocationWidget) {
          initializeMapLocationFields(defaultValues, context.form);
        }
        if (field.type == fieldTypes.bankDetailsWidget) {
          initializeBankDetailsFields(defaultValues, context.form);
        }
      });  
    }

    initializeFields(newFields);

    return {
      error,
      isLoading,
      title,
      description,
      formSettings,
      fields: newFields,
      defaultValues,
    };
  }, [form, context]);

  return {
    defaultValues,
    title,
    description,
    formSettings,
    error,
    isLoading,
    fields,
  };
};
